import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import giftIconJson from '../../../assets/missions/gift-icon-sprite.json';
import giftIconSprite from '../../../assets/missions/gift-icon-sprite.png';
import { useSpriteSheet, type SpriteSheetAsset } from '../../../hooks/useSpriteSheet';
import type { BundleItem } from '../../../stores/rewards/types';
import { formatValueWithK } from '../../../utils/helpers';
import { BundleItemsRenderer } from '../../BundleItemsRenderer/BundleItemsRenderer';
import { CoinWithValue } from '../../CoinWithValue/CoinWithValue';
import { SpriteAnimation } from '../../EventTriggerDialog/road/components/SpriteAnimation/SpriteAnimation';
import { DynamicTooltip } from '../../Tooltip/DynamicTooltip';

import classes from './GiftTooltip.module.scss';

const GRAND_PRIZE_GIFT_ICON_SPRITE: SpriteSheetAsset = {
  imageSrc: giftIconSprite,
  dataSrc: JSON.stringify(giftIconJson),
  frameCount: 30,
  animationDuration: 600,
};

export type GiftTooltipProps = {
  scCoin: number;
  gcCoin: number;
  bundleItems?: BundleItem[] | null;
  playAnimation?: boolean;
};

export const GiftTooltip = ({ scCoin, gcCoin, bundleItems, playAnimation }: GiftTooltipProps) => {
  const { t } = useTranslation();
  // Div ref so it works for both the SpriteAnimation wrapper and the image wrapper (tooltip target).
  const iconRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const giftSpriteState = useSpriteSheet(GRAND_PRIZE_GIFT_ICON_SPRITE);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <SpriteAnimation
        className={classes.grandPrizeGiftIcon}
        frameInterval={
          giftSpriteState.frameCount ? giftSpriteState.animationDuration / giftSpriteState.frameCount : undefined
        }
        idleFrame={'first'}
        isPlaying={!!playAnimation}
        refProp={iconRef}
        scale={0.8}
        sprite={giftSpriteState}
        onClick={handleClick}
      />
      <DynamicTooltip
        arrowAlign="dynamic"
        isOpen={isOpen}
        position="bottom"
        targetRef={iconRef}
        onClose={() => setIsOpen(false)}
      >
        <div className={classes.giftTooltip}>
          <BundleItemsRenderer
            hidePlus
            bundleItems={bundleItems || []}
            className={classes.dailyMissionsGiftTooltipBundleItems}
            direction={'vertical-v2'}
            frbWidgetWidth={35}
            snappyGiftWidgetWidth={30}
          />
          {scCoin > 0 && (
            <CoinWithValue isPile coinSide="top" coinType="SC" valueClassName={classes.coinValue}>
              <span className={classes.coinValue}>{scCoin.toLocaleString()}</span>
            </CoinWithValue>
          )}
          {gcCoin > 0 && (
            <CoinWithValue isPile coinSide="top" coinType="GC" valueClassName={classes.coinValue}>
              <span className={classes.coinValue}>{formatValueWithK(gcCoin, t)}</span>
            </CoinWithValue>
          )}
        </div>
      </DynamicTooltip>
    </>
  );
};
